import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { CONSTANTS, Constants } from '../commons/injection.token';
import { CompanyModules } from '../models/company.model';
import { User } from '../models/user.model';

const execGuardModules = (moduleName: string, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const constants: Constants = inject(CONSTANTS);
  const user: User = JSON.parse(localStorage.getItem(constants['currentUser']))?.user;
  if (!!user && user.company && user.company.modules) {
    return user.company.modules[moduleName] || false;
  }
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

export const authGuardModuleCampaign: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleCampaign', state);
};

export const authGuardModuleCSAT: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleCSAT', state);
};

export const authGuardModuleTrendVoip: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleTrendVoip', state);
};

export const authGuardModuleCustomerPortfolio: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleCustomerPortfolio', state);
};

export const authGuardModuleTracking: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleTracking', state);
};

export const authGuardModuleWebhook: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleWebhook', state);
};

export const authGuardModuleWebhookSantri: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleWebhookSantri', state);
};

export const authGuardModulePipedrive: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('modulePipedrive', state);
};

export const authGuardModuleAgendor: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleAgendor', state);
};

export const authGuardModuleIntegrations: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const constants: Constants = inject(CONSTANTS);
  const user: User = JSON.parse(localStorage.getItem(constants['currentUser']))?.user;
  if (!!user && user.company && user.company.modules) {
    const modules: CompanyModules = user.company.modules
    return modules.moduleWebhook || modules.moduleWebhookSantri || modules.modulePipedrive || modules.moduleAgendor || modules.moduleOpenAI || modules.moduleTrendGPT;
  }
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

export const authGuardModuleOpenAI: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleOpenAI', state);
};

export const authGuardModuleTrendGPT: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleTrendGPT', state);
};

export const authGuardModuleCRM: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleCRM', state);
};

export const authGuardModuleAPI: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleAPI', state);
};

export const authGuardModuleChat: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return execGuardModules('moduleChat', state);
};

export const authGuardModuleAI: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const constants: Constants = inject(CONSTANTS);
  const user: User = JSON.parse(localStorage.getItem(constants['currentUser']))?.user;
  if (!!user && user.company && user.company.modules) {
    const modules: CompanyModules = user.company.modules
    return modules.moduleOpenAI || modules.moduleTrendGPT;
  }
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

